import * as clipboardHelpers from '../helpers/clipboard.js';
import * as customizedTagify from '../helpers/customized_tagify.js';
import { prepareUnclosedMixTagOpeners, restoreUnclosedMixTagOpeners } from '../helpers/tagify_unclosed_mix_openers.js';
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tagify"
export default class extends Controller {
  // NOTE: This replaces the `turbo:load` event listener from before when we did
  // not use turbo frames. This is not the best looking solution but it works.
  // It expects the tagify controller to be mounted anywhere in the DOM where
  // the tagify fields and the `data-previous_steps` attribute are present.
  connect() {
    if (!customizedTagify.canMakeTagifyForStepInput()) {
      return
    }

    const tagifyFields = document.querySelectorAll('input.tagify');
    const tagifyFieldsList = [].slice.call(tagifyFields);

    if (tagifyFieldsList.length) {
      tagifyFieldsList.forEach(function (field) {
        // Verify that this is actually an input element, not a tags element
        if (field.tagName !== 'INPUT') {
          return;
        }

        const wrapper = field.closest('.tagify-parent-wrapper');
        if (!wrapper) {
          return;
        }

        let replacementToken = null;

        // Find hidden input by name within the same wrapper
        if (field.dataset.targetName) {
          const targetName = field.dataset.targetName;
          const allHiddenInputs = wrapper.querySelectorAll('input[type="hidden"]');

          for (const input of allHiddenInputs) {
            if (input.name === targetName && input.closest('.tagify-parent-wrapper') === wrapper) {
              const preparedValue = prepareUnclosedMixTagOpeners(input.value);
              field.value = preparedValue.value;
              replacementToken = preparedValue.token;
              break;
            }
          }
        }

        const tagifyInstance = customizedTagify.makeTagifyForStepInput(field);
        restoreUnclosedMixTagOpeners(tagifyInstance, replacementToken);
      });
    }

    if (typeof document.tagifyCopyEventInitialized === 'undefined') {
      document.tagifyCopyEventInitialized = true;
      document.addEventListener('copy', async (event) => {
        if (event.target.classList.contains('tagify-inner-input')) {
          return clipboardHelpers.handleSubFieldCopy(event);
        }
      });
    }

    if (typeof document.tagifyPasteEventInitialized === 'undefined') {
      document.tagifyPasteEventInitialized = true;
      document.addEventListener('paste', async (event) => {
        if (event.target.classList.contains('tagify-inner-input')) {
          return clipboardHelpers.handleSubFieldPaste(event);
        }

        const wrapper = event.target.closest('.tagify-parent-wrapper');
        if (wrapper == null) return;

        setTimeout(() => {
          // Ugly fix for dropdown delay
          if (document.querySelector('.tagify__dropdown')) {
            document.querySelector('.tagify__dropdown').remove();
          }
        }, 100)

        event.stopPropagation();
        event.preventDefault();
      });
    }

    if (typeof document.tagifyClickEventInitialized === 'undefined') {
      document.tagifyClickEventInitialized = true;
      document.addEventListener('click', async (event) => {
        if (event.target.closest('.copy-button[data-tagify-copy]')) {
          event.preventDefault();

          const wrapper = event.target.closest('.tagify-parent-wrapper');
          const targetElement = wrapper.querySelector('input[type="hidden"]');

          if (!targetElement) {
            console.error('Field not found');
            return;
          }

          try {
            await clipboardHelpers.setClipboardData(event, targetElement.value);
            this.showCopySuccess(wrapper);
          } catch (error) {
            console.error('Failed to copy to clipboard:', error);
            this.showCopyError(wrapper);
          }

          event.stopPropagation();
        }
      });
    }
  }

  showCopySuccess(wrapper) {
    this.showFlashMessage(wrapper, 'successFlash');
  }

  showCopyError(wrapper) {
    this.showFlashMessage(wrapper, 'errorFlash');
  }

  showFlashMessage(wrapper, templateTarget) {
    const template = wrapper.querySelector(`[data-tagify-target="${templateTarget}"]`);
    if (template) {
      const flashesContainer = document.getElementById('flashes');
      if (flashesContainer) {
        const flashElement = document.createElement('div');
        flashElement.innerHTML = template.innerHTML;
        flashesContainer.appendChild(flashElement.firstElementChild);
      }
    }
  }
}
